import React from 'react';
import { Search, Bell, User } from 'lucide-react';
export function TopBar() {
  return <header className="bg-white border-b border-gray-200 px-6 py-4" data-id="element-206">
      <div className="flex items-center justify-between" data-id="element-207">
        <div className="flex-1 max-w-2xl" data-id="element-208">
          <div className="relative" data-id="element-209">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} data-id="element-210" />
            <input type="text" placeholder="Rechercher un chantier, client, AO..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-211" />
          </div>
        </div>
        <div className="flex items-center space-x-4 ml-6" data-id="element-212">
          <button className="relative p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-213">
            <Bell size={20} data-id="element-214" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" data-id="element-215" />
          </button>
          <button className="flex items-center space-x-3 p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-216">
            <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-217">
              <User size={18} className="text-white" data-id="element-218" />
            </div>
            <div className="text-left" data-id="element-219">
              <p className="text-sm font-medium text-gray-900" data-id="element-220">Jean Tremblay</p>
              <p className="text-xs text-gray-600" data-id="element-221">Directeur</p>
            </div>
          </button>
        </div>
      </div>
    </header>;
}